/** Origin of the stream-sansar backend (VITE_UNIVERSE_API_BASE); empty means same-origin. */
export const API_BASE = String(import.meta.env.VITE_UNIVERSE_API_BASE ?? '')
  .trim()
  .replace(/\/$/, '');
